import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/bootstrap.js",
    "revision": "3ae5cb7b92474238c9cd6c9667771e8f"
  },
  {
    "url": "js/main.js",
    "revision": "9f6e65617cb7b7a67185b05427d97feb"
  },
  {
    "url": "js/app.min.js",
    "revision": "4f196ef1365d6ef38d2c681480ce618d"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "65998885ad5af2f6a14315f3cd9e4d4c"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "5e2f2f82277b2cfc4c20b65da19bd1ca"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "04c8d9b709f15514592b337ad33aad74"
  },
  {
    "url": "js/math-print.js",
    "revision": "cf64f6a493a8cb5079f2b70813e478d7"
  },
  {
    "url": "index.html",
    "revision": "9de11c65ec13b24c73ace7042bc529cc"
  },
  {
    "url": "open.html",
    "revision": "d71816b3b00e769fc6019fcdd6921662"
  },
  {
    "url": "shortcuts.svg",
    "revision": "2381dd779ce6cfee954042a7f784c7e6"
  },
  {
    "url": "styles/fonts/ArchitectsDaughter-Regular.ttf",
    "revision": "31c2153c0530e32553b31a49b3d70736"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "23cbac10c03279392888893b3f694007"
  },
  {
    "url": "styles/high-contrast.css",
    "revision": "4ecc9f6d08787a9e2d29dacf7aadd1ca"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "505e8280346666f7ee801bc59521fa67"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "86b7857f02304c6d7039d147014955ef"
  },
  {
    "url": "connect/jira/editor-1-3-3.html",
    "revision": "41dc8af9576b47f359cff19fff7a41c2"
  },
  {
    "url": "connect/jira/viewerPanel-1-3-12.html",
    "revision": "4836f5e4308abe57830e441518364f23"
  },
  {
    "url": "connect/jira/viewerPanel2.html",
    "revision": "0dd1ee1343a46b5c03aedbc587450b84"
  },
  {
    "url": "connect/jira/fullScreenViewer-1-3-3.html",
    "revision": "abed474e47c0c41a5ad2366b4828f77a"
  },
  {
    "url": "connect/jira/viewerPanel.js",
    "revision": "75f816c208d0c621e3066a97ff0ee6cf"
  },
  {
    "url": "connect/jira/spinner.gif",
    "revision": "7d857ab9d86123e93d74d48e958fe743"
  },
  {
    "url": "connect/jira/editor.js",
    "revision": "ce61a0e62031a160e057809fefe64aa2"
  },
  {
    "url": "connect/jira/fullscreen-viewer-init.js",
    "revision": "d3269625ce04b7a277b779ff175957d0"
  },
  {
    "url": "connect/jira/fullscreen-viewer.js",
    "revision": "8eceb2fe587296dd11f9c8f6eae34c20"
  },
  {
    "url": "plugins/connectJira.js",
    "revision": "c4cb6b60234b04b2c8bc09e555746615"
  },
  {
    "url": "plugins/cConf-comments.js",
    "revision": "6deea8e9b96ff96043cd5cfd2a242a9f"
  },
  {
    "url": "plugins/cConf-1-4-8.js",
    "revision": "42137930327ac2a2500f711352b35e25"
  },
  {
    "url": "connect/confluence/connectUtils-1-4-8.js",
    "revision": "25c061e619a1bdbce765821594f0f79d"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "740dce44cf53499f476ee8edc37d09a0"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "3bb38a5d9186a896ed04808e921ef888"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "5fb6ff1a73f54a9086b7a7e1f613b8ed"
  },
  {
    "url": "connect/confluence/viewer-init.js",
    "revision": "b82e366bf57ecced9435c2a8ba9cb9b9"
  },
  {
    "url": "connect/confluence/viewer.js",
    "revision": "fdb5a8e9f7cd3114a9f695348b93d207"
  },
  {
    "url": "connect/confluence/viewer-1-4-42.html",
    "revision": "69c1bca25fd4889bf832e8441c972268"
  },
  {
    "url": "connect/confluence/macroEditor-1-4-8.html",
    "revision": "4ad77ae3f08c19eddac932b2fa8c7068"
  },
  {
    "url": "connect/confluence/includeDiagram-1-4-8.js",
    "revision": "5b9f2e79efc7cadba0c06301edbeeff1"
  },
  {
    "url": "connect/confluence/includeDiagram.html",
    "revision": "01b04b3f54f1e2e63fcf1df033d24519"
  },
  {
    "url": "connect/confluence/macro-editor.js",
    "revision": "c4c110650228d22b021ebad4d6ef021e"
  },
  {
    "url": "math/es5/startup.js",
    "revision": "dc7130cdc866593293dbb5dde11ceb40"
  },
  {
    "url": "math/es5/core.js",
    "revision": "f71bc0bfb7d2ac8261747f97a5d47dd4"
  },
  {
    "url": "math/es5/ui/safe.js",
    "revision": "8c1fcfee7c879588ad409edcdd9cce53"
  },
  {
    "url": "math/es5/output/svg.js",
    "revision": "4f55967d16197ebb01b86356d8ab179a"
  },
  {
    "url": "math/es5/input/tex.js",
    "revision": "5c4f470da2ccb1acf85041fcecd6fff6"
  },
  {
    "url": "math/es5/input/asciimath.js",
    "revision": "c2d4076dd8e26d509bfe3a378e71cfa7"
  },
  {
    "url": "math/es5/output/svg/fonts/tex.js",
    "revision": "6eab785a3788ea805bd2b552d1f0aab8"
  },
  {
    "url": "resources/dia.txt",
    "revision": "66fe818e43b096f060797233ac192e69"
  },
  {
    "url": "resources/dia_am.txt",
    "revision": "c0fd8663e0a62b5d5f8efa5d26bae111"
  },
  {
    "url": "resources/dia_ar.txt",
    "revision": "c4d18588423c38f5852bdcfc172e208a"
  },
  {
    "url": "resources/dia_bg.txt",
    "revision": "f62cd6360a374ffecce77faf4794c633"
  },
  {
    "url": "resources/dia_bn.txt",
    "revision": "d707c8c6078edfb5efa7ee104a1b308a"
  },
  {
    "url": "resources/dia_bs.txt",
    "revision": "38251947885f4839b68dc8a549bd7ed4"
  },
  {
    "url": "resources/dia_ca.txt",
    "revision": "7ee3bb34b78d1e0500ffcbc41096a8d1"
  },
  {
    "url": "resources/dia_cs.txt",
    "revision": "ad59ba3f2b0e56b65409c638321f79fb"
  },
  {
    "url": "resources/dia_da.txt",
    "revision": "2a4b2ad28cadf4590d62d490f88016eb"
  },
  {
    "url": "resources/dia_de.txt",
    "revision": "1388b25f6ecde6e330bf323017062c70"
  },
  {
    "url": "resources/dia_el.txt",
    "revision": "09dcfec3d8a46590ba57cdf4d02be070"
  },
  {
    "url": "resources/dia_eo.txt",
    "revision": "25a03963c9cfcbee5f5f036642a2aebf"
  },
  {
    "url": "resources/dia_es.txt",
    "revision": "68daba33593d4fb5a1004ab3b6ac984d"
  },
  {
    "url": "resources/dia_et.txt",
    "revision": "d2263aa741354845c99cc9fbd8df4e18"
  },
  {
    "url": "resources/dia_eu.txt",
    "revision": "af75a906812f22a72dbd7ebfa3abb774"
  },
  {
    "url": "resources/dia_fa.txt",
    "revision": "e3b98b37044922eb1177fcea6522878d"
  },
  {
    "url": "resources/dia_fi.txt",
    "revision": "907d9fe446b952128cd3bf71a8bcedeb"
  },
  {
    "url": "resources/dia_fil.txt",
    "revision": "cbca0d5f0c3b89d5d91d2ea905ad8ce1"
  },
  {
    "url": "resources/dia_fr.txt",
    "revision": "8641024bf63230b2786879723aaf0f0a"
  },
  {
    "url": "resources/dia_gl.txt",
    "revision": "a000c015dc0227ac87b68431ac5c80f4"
  },
  {
    "url": "resources/dia_gu.txt",
    "revision": "8a67215da2b9e9b3322d2173a9f65356"
  },
  {
    "url": "resources/dia_he.txt",
    "revision": "0cef56f4df9ce16fa29d120bcbb8eb2b"
  },
  {
    "url": "resources/dia_hi.txt",
    "revision": "db1a67a897d2cc5cc22970a106a50e46"
  },
  {
    "url": "resources/dia_hr.txt",
    "revision": "4f89a72eb120955e11b356f2c872a281"
  },
  {
    "url": "resources/dia_hu.txt",
    "revision": "99269600dcb315735a8ce21c8f28655c"
  },
  {
    "url": "resources/dia_id.txt",
    "revision": "d571f949ace55bb011ab43c91f833b8e"
  },
  {
    "url": "resources/dia_it.txt",
    "revision": "7ff410073cee5c90d87df5dd7afd9a52"
  },
  {
    "url": "resources/dia_ja.txt",
    "revision": "6d704659a921836bac933bbc8e2cf935"
  },
  {
    "url": "resources/dia_kn.txt",
    "revision": "7f99194e2e72553d47d19d737dea8eb0"
  },
  {
    "url": "resources/dia_ko.txt",
    "revision": "96c2009c94ce23da09702e42de356231"
  },
  {
    "url": "resources/dia_lt.txt",
    "revision": "2c757c6c99b0818057d38e9acf10e314"
  },
  {
    "url": "resources/dia_lv.txt",
    "revision": "0ea1bc7bb50a59c5cd5e0877945e12ec"
  },
  {
    "url": "resources/dia_ml.txt",
    "revision": "fbb7a7720e50fd64831f7e39f3c89e7a"
  },
  {
    "url": "resources/dia_mr.txt",
    "revision": "20a45f7661eed9859c78f7ceb9238f17"
  },
  {
    "url": "resources/dia_ms.txt",
    "revision": "e5036c01058d8ea7646a45026e78af9e"
  },
  {
    "url": "resources/dia_my.txt",
    "revision": "b89a747bae305ccc5279c7bd3853daca"
  },
  {
    "url": "resources/dia_nl.txt",
    "revision": "cc83861bad1c0ee6407033e11dcf2a6e"
  },
  {
    "url": "resources/dia_no.txt",
    "revision": "e91861e0c63e84f29d55a1f3f2607302"
  },
  {
    "url": "resources/dia_pl.txt",
    "revision": "4576ed4793b8b1b6cea9e42e43563ff8"
  },
  {
    "url": "resources/dia_pt-br.txt",
    "revision": "c34ebc456f289c9a0fa439f634f1780f"
  },
  {
    "url": "resources/dia_pt.txt",
    "revision": "4edd5e515438c38e3f1dc740a9004fd1"
  },
  {
    "url": "resources/dia_ro.txt",
    "revision": "bf85989de210da251b823dbf8be756e9"
  },
  {
    "url": "resources/dia_ru.txt",
    "revision": "40a32183dfcd22b3f1cbef39010193a4"
  },
  {
    "url": "resources/dia_si.txt",
    "revision": "fbe4cc15f899360a7ad34d2887a83248"
  },
  {
    "url": "resources/dia_sk.txt",
    "revision": "0e79ad989e1025b9c7ddf08c87852db8"
  },
  {
    "url": "resources/dia_sl.txt",
    "revision": "8dfdfe1b3c92acc911ab8dfee527d106"
  },
  {
    "url": "resources/dia_sr.txt",
    "revision": "62aa3d55147b6557572cdc8e16e7f2d3"
  },
  {
    "url": "resources/dia_sv.txt",
    "revision": "3c57d2ea15c35e317b17594b027a733f"
  },
  {
    "url": "resources/dia_sw.txt",
    "revision": "3bf4f975754200946b94385b8616fb4d"
  },
  {
    "url": "resources/dia_ta.txt",
    "revision": "47cb2e2a7b601ecf077c749d56f81b9b"
  },
  {
    "url": "resources/dia_te.txt",
    "revision": "01a0964d568928371babbbb5d624bc50"
  },
  {
    "url": "resources/dia_th.txt",
    "revision": "16d403b392b3bab68acea7d4a3907108"
  },
  {
    "url": "resources/dia_tr.txt",
    "revision": "765c31a13343c16aaa0caae6ae1b9d41"
  },
  {
    "url": "resources/dia_uk.txt",
    "revision": "7f52bf751963c3ecdf7bd7d62d105267"
  },
  {
    "url": "resources/dia_vi.txt",
    "revision": "847c74fd08d2a5a5a0432a6a82ed2660"
  },
  {
    "url": "resources/dia_zh-tw.txt",
    "revision": "83a6822b1e5d4ab4ccde1a8b4cc10413"
  },
  {
    "url": "resources/dia_zh.txt",
    "revision": "e1b3588ff3149ec2123d1dd5c1f2e77a"
  },
  {
    "url": "favicon.ico",
    "revision": "b2bf17349e4b50ce4ba311f079f8bf7d"
  },
  {
    "url": "images/manifest.json",
    "revision": "421b4fae5b46499348d194e1f93558c3"
  },
  {
    "url": "images/logo.png",
    "revision": "e4e0d092abdb1e668b5ec41a7fe0713c"
  },
  {
    "url": "images/drawlogo.svg",
    "revision": "4bf4d14ebcf072d8bd4c5a1c89e88fc6"
  },
  {
    "url": "images/drawlogo48.png",
    "revision": "8b13428373aca67b895364d025f42417"
  },
  {
    "url": "images/drawlogo-gray.svg",
    "revision": "0aabacbc0873816e1e09e4736ae44c7d"
  },
  {
    "url": "images/drawlogo-text-bottom.svg",
    "revision": "f6c438823ab31f290940bd4feb8dd9c2"
  },
  {
    "url": "images/logo-flat-small.png",
    "revision": "4b178e59ff499d6dd1894fc498b59877"
  },
  {
    "url": "images/apple-touch-icon.png",
    "revision": "732c29e21332a926318a7005d21ec450"
  },
  {
    "url": "images/icon-192-maskable.png",
    "revision": "47e006d0ce4a35eb5beaa97f0c2bfed0"
  },
  {
    "url": "images/icon-192.png",
    "revision": "d022403d52435d76afec82c4e24a17ef"
  },
  {
    "url": "images/icon-512-maskable.png",
    "revision": "cf152feeb01fb21f3148a71a3540266e"
  },
  {
    "url": "images/icon-512.png",
    "revision": "a3a0df7e7a385244b74073f81ecc45de"
  },
  {
    "url": "images/delete.png",
    "revision": "5f2350f2fd20f1a229637aed32ed8f29"
  },
  {
    "url": "images/droptarget.png",
    "revision": "bbf7f563fb6784de1ce96f329519b043"
  },
  {
    "url": "images/logo-flat.png",
    "revision": "038070ab43aee6e54a791211859fc67b"
  },
  {
    "url": "images/google-drive-logo.svg",
    "revision": "5d9f2f5bbc7dcc252730a0072bb23059"
  },
  {
    "url": "images/onedrive-logo.svg",
    "revision": "3645b344ec0634c1290dd58d7dc87b97"
  },
  {
    "url": "images/dropbox-logo.svg",
    "revision": "e6be408c77cf9c82d41ac64fa854280a"
  },
  {
    "url": "images/github-logo.svg",
    "revision": "a1a999b69a275eac0cb918360ac05ae1"
  },
  {
    "url": "images/gitlab-logo.svg",
    "revision": "0faea8c818899e58533e153c44b10517"
  },
  {
    "url": "images/trello-logo.svg",
    "revision": "006fd0d7d70d7e95dc691674cb12e044"
  },
  {
    "url": "images/osa_drive-harddisk.png",
    "revision": "b954e1ae772087c5b4c6ae797e1f9649"
  },
  {
    "url": "images/osa_database.png",
    "revision": "c350d9d9b95f37b6cfe798b40ede5fb0"
  },
  {
    "url": "images/google-drive-logo-white.svg",
    "revision": "f329d8b1be7778515a85b93fc35d9f26"
  },
  {
    "url": "images/dropbox-logo-white.svg",
    "revision": "4ea8299ac3bc31a16f199ee3aec223bf"
  },
  {
    "url": "images/onedrive-logo-white.svg",
    "revision": "b3602fa0fc947009cff3f33a581cff4d"
  },
  {
    "url": "images/github-logo-white.svg",
    "revision": "537b1127b3ca0f95b45782d1304fb77a"
  },
  {
    "url": "images/gitlab-logo-white.svg",
    "revision": "5fede9ac2f394c716b8c23e3fddc3910"
  },
  {
    "url": "images/trello-logo-white-orange.svg",
    "revision": "e2a0a52ba3766682f138138d10a75eb5"
  },
  {
    "url": "images/logo-confluence.png",
    "revision": "ed1e55d44ae5eba8f999aba2c93e8331"
  },
  {
    "url": "images/logo-jira.png",
    "revision": "f8d460555a0d1f87cfd901e940666629"
  },
  {
    "url": "images/spin.gif",
    "revision": "487cbb40b9ced439aa1ad914e816d773"
  },
  {
    "url": "images/aui-wait.gif",
    "revision": "5a474bcbd8d2f2826f03d10ea44bf60e"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "81d1704d5ab9207e2e5c7fc84379dc1a"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








